<div class="bg-primary rounded-top d-flex justify-content-center py-4">
    <div class="icp-logo-negative icp-icon-64"></div>
</div>
<div class="p-3">
    <div class="py-3" [innerHTML]="'footer-impressum-modal' | translate"></div>
    <button class="w-100 btn btn-primary mb-3" (click)="closeModal()">{{"common-got-it" | translate}}</button>
</div>